<template>
  <div>
    <label class="item-name"><i class="required" v-show="component.properties.required">*</i>{{initComponent.name}}</label>
    <div class="component-content">
      <el-rate :colors="['#55ACF1', '#55ACF1', '#55ACF1']" :class="{onlyread:component.properties.readonly}" v-model="value" disabled/>
    </div>
  </div>
</template>

<script>
import { componentMixin } from '../mixins'

export default {
  name: 'rc-rate',
  props: ['initComponent'],
  mixins: [ componentMixin ],
  data () {
    return {
      value: 1,
      component: this.initComponent
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/components/rate/rc-rate.vue